<div class="highlight-logos-container" (sdxInView)="inView = true" [@staggerIn]="inView">
  <div class="highlight-logo-group" *ngFor="let group of groups; trackBy: trackByFnc">
    <picture *ngFor="let n of group" class="stagger-in highlight-logo lazyload-picture" [ngClass]="{'is-ready': n.isLoaded}">
      <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class="lazyload-img" [alt]="n.alt_text" [sdxLazyload]="n.imageSources" [lazyloadIf]="inView" (lazyloaded)="n.isLoaded = true" />
    </picture>
  </div>
</div>
